
















    import {Component} from "vue-property-decorator";
    import {WarehouseStore} from "../store";
    import WarehouseTable from "@/modules/warehouses/shared/components/WarehouseTable/index.vue";
    import StockSearch from "@/modules/warehouses/Stock/components/Search.vue";
    import {mixins} from "vue-class-component";
    import {CommonMixin} from "@/shared/services/mixin";
    import {RoleDeclare} from "@/enums/roledeclare";
import { DashboardStore } from "@/modules/dashboard/store";

    @Component({
        name: "Stock",
        components: {StockSearch, WarehouseTable }
    })
    export default class extends mixins(CommonMixin) {
      async mounted() {
            await this.fetchOrderData();
        }
      ortherOrders = 0;
      issueOrders = 0;
      returnOrders = 0;

        async fetchOrderData() {
            try {
              const data = await DashboardStore.getStatisticRow3();
                console.log("data =", data);
                this.issueOrders = data[0].value;
                this.returnOrders = data[1].value;
                this.ortherOrders = data[2].value;
            } catch (error) {
                console.error('Error fetching order data:', error);
            }
        }

        get warehouses() {
            return WarehouseStore.ids.map((id: number, index: number) => ({ ...WarehouseStore.data[id], stt: index + 1}));
        }

        onChangePage(pagination) {
            WarehouseStore.stock({ ...WarehouseStore.params, page: pagination.current, limit: pagination.pageSize })
        }

        stockIn() {
          if (!this.hasPermission(RoleDeclare.ROLE_CAN_STOCK_IN) && !this.hasPermission(RoleDeclare.ROLE_CAN_STOCK_IN_FAST)) {
            this.$notification.warn({
              message: "Từ chối truy cập",
              description: "Bạn không có quyền truy cập"
            })
            return;
          }else {
            this.$router.push({ name: "stockIn" });
          }
        }
    }
